import { min, max, inRange, round, times, reduce, isFinite } from 'lodash-es';

const negativeColors = ['#E19FA1', '#E7B2B3', '#EDC5C6', '#F3D9D9', '#F9ECEC'];
const positiveColors = ['#EAF1F9', '#D5E4F3', '#C0D6ED', '#ABC9E7', '#96BBE1'];

const makeNumbersRange = (values, bucketCount = 5) => {
  const numericValues = values.reduce((result, item) => {
    const parsed = parseFloat(item);
    return Number.isNaN(parsed) ? result : result.concat(parsed);
  }, []);

  if (numericValues.length === 0) return [];

  const minValue = min(numericValues);
  const maxValue = max(numericValues);
  const step = round((maxValue - minValue) / bucketCount, 2);

  const breakpoints = times(bucketCount, (index) => round(minValue + index * step, 2)).concat(
    maxValue
  );

  const pairs = [];
  for (let i = 0; i < breakpoints.length - 1; i++) {
    pairs.push([breakpoints[i], breakpoints[i + 1]]);
  }

  return pairs;
};

const makeRangeMatcher = (numbersRange) => {
  if (!numbersRange.length) return [() => true];

  return numbersRange.map(([start, end], index) => {
    const isLastBucket = index === numbersRange.length - 1;

    return (value) => (isLastBucket ? value >= start && value <= end : inRange(value, start, end));
  });
};

export const createHeatmapColorizer = (dateTimeValueSeriesArray) => {
  const { positive, negative } = reduce(
    dateTimeValueSeriesArray,
    (acc, item) => {
      const parsedValue = parseFloat(item[1]);
      if (isFinite(parsedValue)) {
        acc[parsedValue >= 0 ? 'positive' : 'negative'].push(parsedValue);
      }
      return acc;
    },
    { positive: [], negative: [] }
  );

  const positiveRange = positive.length ? makeNumbersRange(positive) : [];
  const negativeRange = negative.length ? makeNumbersRange(negative) : [];

  const getBackground = (point) => {
    if (point === 'na') return '#F8F9FB';

    const pointValue = parseFloat(point);

    if (!isFinite(pointValue)) return null;
    if (pointValue === 0) return '#ffffff';

    const heatColors = pointValue >= 0 ? positiveColors : negativeColors;
    const matchRange = pointValue >= 0 ? positiveRange : negativeRange;
    const rangeMatcher = makeRangeMatcher(matchRange);

    const result = heatColors[rangeMatcher.findIndex((isMatch) => isMatch(pointValue))];

    return result;
  };

  return {
    getBackground,
  };
};
